import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import useQuery from 'core/hooks/useQuery';
import { useBookingsV2 } from 'core/contexts/bookingV2';
import { toast } from 'react-toastify';
import { ROUTES } from 'core/routing/routes';
import { PaymentPlatform } from '@utriper/core';
import { CircularIndeterminate } from '@utriper/core-ui';

const PaymentValidation = () => {
    const history = useHistory();
    const query = useQuery();
    const { confirmBooking } = useBookingsV2();
    const [status, setStatus] = useState(null);
    const [bookingId, setBookingId] = useState('');

    useEffect(() => {
        const sessionId = query.get('session_id');
        const paymentId = query.get('payment');
        setBookingId(query.get('booking'));

        const execute = async () => {
            const result = await confirmBooking({
                paymentId,
                paymentUID: paymentId,
                sessionId,
                status: 'approved',
                statusId: 3,
                paymentPlatformId: PaymentPlatform.IDS.stripe,
            });

            setStatus(result?.status);
        };

        execute();
    }, []);

    useEffect(() => {
        if (status === 'open' || status === 'failure') {
            toast.error(`Hubo un error al intentar crear la reserva!`, {
                position: 'top-right',
                theme: 'colored',
            });
            history.push(ROUTES.BOOKINGS.NEW);
        }

        if (status === 'approved') {
            toast.success(`Reserva creada con éxito!`, {
                position: 'top-right',
                theme: 'colored',
            });
            history.push(`${ROUTES.BOOKINGS.GLOBAL}/${bookingId || ''}`);
        }
    }, [status]);

    return <CircularIndeterminate centered={true} />;
};

export default PaymentValidation;
